import { render, staticRenderFns } from "./VFileInputDropzone.vue?vue&type=template&id=6bd94c9c"
import script from "./VFileInputDropzone.vue?vue&type=script&lang=js"
export * from "./VFileInputDropzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports